import * as React from 'react'
import useSWR from 'swr'
import axios from 'axios'
import { useLocale, useTranslation } from 'hooks'
import { withTranslations } from 'helpers'
import Chip from '../atoms/Chip'
import * as S from './ChipCarousel.styles'

interface HomepagePill {
  id: number
  label: string
  url: string
  display_order: number
}

interface PillsResponse {
  homepage_pills: HomepagePill[]
}

const ChipCarousel = () => {
  const { t } = useTranslation()
  const { localiseUrl } = useLocale()
  const { data } = useSWR(
    '/api/v1/homepage_pills',
    (url) =>
      axios.get(url).then((response) => response.data as PillsResponse),
    { revalidateOnFocus: false }
  )

  const pills = data?.homepage_pills || []

  return (
    <S.ChipCarousel>
      <Chip
        href={localiseUrl(`${window.location.origin}/account/selling/new`)}
        type="primary"
      >
        {t('shared.sell_item')}
      </Chip>
      <S.Divider>{t('shared.or')}</S.Divider>
      {pills.map(({ url, label }) => (
        <Chip
          href={localiseUrl(`${window.location.origin}${url}`)}
          type="secondary"
          key={label}
        >
          {label}
        </Chip>
      ))}
    </S.ChipCarousel>
  )
}

export default withTranslations(ChipCarousel)
